import { Component, OnDestroy, OnInit } from '@angular/core';
import { PopoverRef } from '../../../popovers/popover/popover-ref';
import { BasePopoverComponent } from '../../../classes/BasePopover';
import * as moment from 'moment';
import { TodayDataProviderService } from '../../../services/data-provider/today-data-provider.service';
import { ViewState } from '../../../shared/enums/view-state.enum';
import { map, share } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';

@Component({
    selector: 'app-today-details',
    templateUrl: './today-details.component.html',
    styleUrls: ['./today-details.component.scss'],
    viewProviders: [],
})
export class TodayDetailsComponent extends BasePopoverComponent implements OnInit, OnDestroy {
    LABELS;
    TEXTS;
    protected readonly ViewState = ViewState;

    currentComparisonDate = moment().subtract(7, 'days').toDate();

    infoVisible = false;

    dateChanged = false;

    isAccordionOpen: { [key: string]: boolean } = {};

    todayTileData$ = this.todayDataProviderService.todayTileData$.pipe(share());
    combinedData$ = combineLatest([
        this.todayDataProviderService.todayDetailData$,
        this.todayDataProviderService.todayDetailFullData$,
    ]).pipe(map(([detail, full]) => ({ detail, full })));

    constructor(
        protected popoverRef: PopoverRef,
        private todayDataProviderService: TodayDataProviderService,
        private translate: TranslateService
    ) {
        super(popoverRef);
    }

    ngOnInit() {
        this.todayDataProviderService.getTodayComparisonForSetComparisonDate(
            this.currentComparisonDate
        );
        this.translate.get('screens.dashboard.todayDetail.labels').subscribe((labels: any) => {
            this.LABELS = labels;
        });

        this.translate.get('screens.dashboard.todayDetail.texts').subscribe((texts: any) => {
            this.TEXTS = texts;
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.todayDataProviderService.killDetailSub();
    }

    toggleAccordion(panel: string): void {
        this.isAccordionOpen[panel] = !this.isAccordionOpen[panel];
    }

    onComparisonDateChange(selectedValue: Date) {
        this.currentComparisonDate = selectedValue;
        this.dateChanged = true;
        this.todayDataProviderService.getTodayComparisonForSetComparisonDate(selectedValue);
    }
}
